import { render, staticRenderFns } from "./user-wizard-header.vue?vue&type=template&id=f84c16da"
import script from "./user-wizard-header.vue?vue&type=script&lang=js"
export * from "./user-wizard-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports